import { Result } from "@/frontend/components/common";

export function NotFoundPage() {
  return <Result type="404" />;
}
